<template>
  <a-modal width="700px" v-model="isShow" :closable="false" :title="title" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
      <a-form-model-item label="发布平台" prop="line_id">
        <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 100%">
          <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="地图类型" prop="category">
        <a-select v-model="form.category" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 100%" @change="handleCancelCategory" :disabled="isEdit">
          <a-select-option v-for="item in WEBSITE_MAP_CATEGORY" :key="item.key" :value="item.key">{{
            item.value
          }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.category===1" label="分类" prop="typeids">
        <a-select v-model="form.typeids" mode="multiple" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 100%">
          <a-select-option v-for="item in classifyList" :key="item.id" :value="String(item.id)">
            {{ item.path_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="XML名称" prop="name">
        <a-input v-model.trim="form.name" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="XML名称（拼音）" prop="pinyin">
        <a-input v-model.trim="form.pinyin" placeholder="请输入" :maxLength="30" />
      </a-form-model-item>
      <a-form-model-item v-if="form.category===1" label="XML同步地址" prop="sync_xml_loc">
        <a-input v-model.trim="form.sync_xml_loc" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="链接规则" prop="loc_rule">
        <a-input v-model.trim="form.loc_rule" placeholder="请输入" />
      </a-form-model-item>
      <span v-show="form.category" style="color: #ccc; margin-top: -26px;float:right;">{{ form.category===2 ? '标签id请用%label%代替' : form.category===3 ? '专题id请用%topic%代替' : '文章分类请用%term%代替，文章id请用%id%代替' }}</span>
      <a-form-model-item label="更新频率" prop="change_freq">
        <a-select v-model.trim="form.change_freq" placeholder="请选择">
          <a-select-option v-for="item in labelList" :key="item.key">
            {{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="权重" prop="priority">
        <a-input v-model.trim="form.priority" placeholder="请输入" style="width: 200px" />
        <span style="color: #ccc; margin-left: 10px">此值定于0.0 - 1.0之间</span>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { form, rules } from '../business/filialeList'
import dialog from '@/composables/dialog'
import compuedFun from '../business/index'
import api from '@/api/'
import storeGlobal from '@/store/'
import login from '@/api/login'

const title = {
  Add: '新增 XML',
  Edit: '编辑 XML'
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    classifyList: {
      type: [Object, Array],
      default() {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: {}
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      title: title.Add,
      btnloading: false,
      principalList: [], // 负责人
      form: { ...form }
    })
    const labelList = computed(() => {
      return storeGlobal.state.label.data.WEBSITE?.WEBSITE_MAP_CHANGE_FREQ
    })

    watch(
      () => _this.params,
      async () => {
        state.form = JSON.parse(JSON.stringify({ ..._this.params }))
        const responsible = state.form.responsible_name + '(' + state.form.responsible_number + ')'
        _this.$set(state.form, 'responsible', responsible)
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )
    // crea
    const methods = {
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async valid => {
          let res = null
          const data = { ...state.form }
          // 验证手机号和座机号是否有一个输入
          if (valid) {
            if (_this.isEdit) {
              res = await api.websiteMapUpdate(data)
            } else {
              res = await api.websiteMapCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
              _this.$refs.formDom.resetFields()
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      },
      handleCancelCategory() {
        if (!_this.isEdit) {
          _this.form.typeids = []
          _this.form.sync_xml_loc = ''
        }
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...methods,
      labelList
    }
  }
})
</script>
